/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

export const ListViewContext = createContext( {
	__experimentalFeatures: false,
	__experimentalPersistentListViewFeatures: false,
} );

export const useListViewContext = () => useContext( ListViewContext );
